import {
  SET_RAM,
  SET_CPU,
  SET_STORAGE,
  SET_RESOURCE,
  SET_RESOURCE_SERVICE,
  SET_DEFAULT_RESOURCE
} from "../mutation-types";

export default {
  [SET_RESOURCE]: ({ commit }) => {
    commit(SET_RESOURCE);
  },
  [SET_DEFAULT_RESOURCE]: ({ commit }) => {
    commit(SET_DEFAULT_RESOURCE);
  },
  [SET_RESOURCE_SERVICE]: ({ commit }, serviceId) => {
    commit(SET_RESOURCE_SERVICE, serviceId);
  },
  [SET_RAM]: ({ commit }, val) => {
    commit(SET_RAM, val);
  },
  [SET_CPU]: ({ commit }, val) => {
    commit(SET_CPU, val);
  },
  [SET_STORAGE]: ({ commit }, val) => {
    commit(SET_STORAGE, val);
  }
};
